import styled from '@emotion/styled';

import { Typography } from '@innovamat/glimmer-components';

import { useStudentAnswer } from '../../../classrooms-management/hooks/use-student-answer';
import { EMPTY_CELL_VALUE } from '../../utils';
import { Correctness, CORRECTNESS_VALUES } from '../../modules/mock-exams/mock-exams';

type StatementCellProps = {
  answer?: string;
  correctness?: Correctness;
  isPercentage?: boolean;
};

const StatementCellContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledText = styled(Typography.Subtitle2)<{ hasNoAnswer: boolean }>`
  color: ${({ hasNoAnswer, theme }) =>
    hasNoAnswer
      ? theme.tokens.color.specific.reports.semantic['no-data'].value
      : 'inherit'};
`;

const BottomLine = styled.div<{ hasNoAnswer: boolean; correctness?: Correctness; }>`
  margin-top: 2px;
  width: 100%;
  height: 4px;
  border-radius: 4px;
  background-color: ${({ hasNoAnswer, correctness, theme }) =>
    hasNoAnswer
      ? theme.tokens.color.specific.reports['progress-bar'].empty.value
      : theme.tokens.color.specific.reports.semantic[correctness === CORRECTNESS_VALUES.YES ? 'high' : correctness === CORRECTNESS_VALUES.NO ? 'low' : 'medium']
          .value};
`;

export function StatementCell({
  answer,
  correctness,
  isPercentage,
}: StatementCellProps): JSX.Element {
  const hasNoAnswer = !answer;
  const { answer: parsedAnswer, isLoading } = useStudentAnswer({
    answer: answer || '',
  });

  const displayValue =
    !isLoading && parsedAnswer
      ? `${parsedAnswer}${isPercentage ? '%' : ''}`
      : EMPTY_CELL_VALUE;

  return (
    <StatementCellContainer>
      <StyledText hasNoAnswer={hasNoAnswer}>{displayValue}</StyledText>
      <BottomLine hasNoAnswer={hasNoAnswer} correctness={correctness} />
    </StatementCellContainer>
  );
}
